import { Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[rlStopPropagation]'
})
export class StopPropagationDirective {

  @HostListener("click", ["$event"])
  stopOnClick = (event : Event) => this.stop(event);

  @HostListener("keydown", ["$event"])
  stopOnEnter(event : any) {
    if (event.keyCode === 13 || event.code === 'Enter' || event.keyCode === 32) {
      this.stop(event);
    }
  }

  stop = (e) => e.stopPropagation() && e.preventDefault();
}